import {
  Component,
  ViewEncapsulation,
  ViewChild,
  Inject,
  inject,
  HostListener,
  ElementRef,
  Directive,
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
} from "@angular/forms";
import { Observable } from "rxjs";
import { StandardService } from "../services/standard.service";
import { LocationType } from "../models/location-type";
import { StandardType } from "../models/standardType";
import { Category } from "../models/category";
import { Standard } from "../models/standard";
import { ActivatedRoute, Router } from "@angular/router";
import { SuccessDialogComponent } from "../success-dialog/success-dialog.component";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import {
  StandardTypeEnum,
  StandardListType,
  UserRoleEnum,
  CategoryEnum,
  MasterDataRequestedType,
} from "../core/constant";
import { EquipmentClassType } from "../models/equipment-class-type";
import { StandardSearchView } from "../models/standard-search-view";
import { CryptographyService } from "../services/cryptography.service";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { SelectedStandard } from "../models/selected-standard";
import { SubLocationType } from "../models/sub-location-type";
import { DataRowOutlet } from "@angular/cdk/table";
import { ModalImageCropperComponent } from "../modal-image-cropper/modal-image-cropper.component";
import { FailModuleComponent } from "../fail-module/fail-module.component";
import { SimpleModalService } from "ngx-simple-modal-eq";
import { Subject } from "rxjs";
import { switchMap, debounceTime, distinctUntilChanged } from "rxjs/operators";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { MatStepper } from "@angular/material/stepper";
import { StepperSelectionEvent } from "@angular/cdk/stepper";
import { Step } from "../stepper/stepper.component";
import { MultiSelectComponent } from "ng-multiselect-dropdown";
import { MatSnackBar } from "@angular/material/snack-bar";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { ChangeDetectorRef } from "@angular/core";
import { Clipboard } from "@angular/cdk/clipboard";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { SnackbarComponent } from "../snackbar/snackbar.component";
import { QuillViewComponent } from "ngx-quill";
import DOMPurify from "dompurify";

declare var $: any;

@Component({
  selector: "app-add-grs",
  templateUrl: "./add-grs.component.html",
  styleUrls: ["./add-grs.component.scss"],
  providers: [
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { showError: true, displayDefaultIndicatorType: false },
    },
  ],
})
export class AddGrsComponent {
  private _snackBar = inject(MatSnackBar);
  @ViewChild("dropdownContainer") dropdownContainer: ElementRef;
  @ViewChild("dropdown") dependentDropdownRef: ElementRef;
  @ViewChild("searchInput") searchInput!: ElementRef;
  @ViewChild("stepper") private stepper: MatStepper;
  @ViewChild("locationDropdown", { static: false })
  @Directive({
    selector: "[matInputAutofocus]",
  })
  locationDropdown!: MultiSelectComponent;
  error: boolean = false;
  startTime: Date | null = null;
  endTime: Date | null = null;
  end: number;
  newCreatedStandard: any = [];
  searchSubject: Subject<string>;
  content: string = "Hello World!";
  loading: boolean = false;
  minimumStandardsLoading: boolean = false;
  globalstandards: boolean = false;
  addGrsForm: FormGroup;
  SelectStandardTypeForm: FormGroup;
  grs: SelectedStandard = new SelectedStandard();
  selected = "option2";
  stateCtrl = new FormControl();
  minimumStandadControl = new FormControl();
  minimumStandads: StandardSearchView[] = [];
  latestSearchResults: any = [];

  invalidImage: boolean = false;
  invalidAttachment: boolean = false;
  invalidImageRes: boolean = false;
  imageChangedEvent: any = "";

  locationTypes: LocationType[] = [];
  filteredLocationTypes: LocationType[] = [];
  standardTypes: StandardType[] = [];
  categories: Category[] = [];
  buildingCategories: Category[] = [];
  operationsCategories: Category[] = [];
  equipmentClassTypes: EquipmentClassType[] = [];
  subLocationTypes: SubLocationType[] = [];

  selectedStandardType: string;
  currentStepIndex: number = 0;

  dependentStandardsItems: any[] = [];
  dependentcategories: any;

  dependentLocations: any;

  formSteps: Step[] = [
    { id: 0, title: "Standard Type", status: "active" },
    { id: 1, title: "Category & Location", status: "inactive" },
    { id: 2, title: "Description", status: "inactive" },
    { id: 3, title: "Details & Media", status: "inactive" },
    { id: 4, title: "Supporting Info", status: "inactive" },
    { id: 5, title: "Review & Submit", status: "inactive" },
  ];

  standardTypeSDescription = [
    {
      name: "Global Building Standards",
      id: 4,
      description:
        "Create a global minimum requirement that defines how restaurants and facilities must be designed, built, or modified across all markets.",
      hint: "Use this when the requirement applies globally and governs physical buildings or infrastructure.",
    },
    {
      name: "Global Approved Solution",
      id: 1,
      description:
        "Create a globally approved solution - which can support restaurants with meeting a Global Minimum Standard  when local conditions, constraints are required.",
      hint: "Use this when markets need an approved option that still complies with global minimum standards.",
    },
    {
      name: "BU Standards",
      id: 7,
      description:
        "Create a Business Unit–specific standard that applies to a defined region, segment, or business unit.",
      hint: "Use this when requirements differ by BU, Segment or Market but are still formally governed.",
    },
    {
      name: "Global Operations Standards",
      id: 8,
      description:
        "Create a standard that defines how restaurants operate, execute, or deliver day‑to‑day processes.",
      hint: "Use this for operational, execution, or procedure related Global Minimum Standards.",
    },
  ];

  categoryForLastPage: string = "";
  lastPageSublocation: string = "";
  lastPagelocations: string = "";
  detailsExpanded = false;
  additionalInfoExpanded = false;

  isDropdownOpen = false;
  LocationsdropdownList = [];
  selectedLocations: any[] = [];
  dropdownSettings: IDropdownSettings;

  categoryDropdownList = [];
  selectedCategory = [];
  categorydropdownSettings: IDropdownSettings;

  sublocationDropdownList = [];
  subLocationselected = [];
  subLocationdropdownSettings: IDropdownSettings;

  minimumStandards = [];
  minimumStandardSelected = [];
  minimumStandardSettings: IDropdownSettings;

  resourceId = 1;

  isCompleted1Step: boolean = false;
  isCompleted2Step: boolean = false;
  resourceLinksValid: boolean = false;
  descriptionChecked: boolean = false;
  isSuccessfull: boolean = false;

  step0Group: FormGroup;
  step1Group: FormGroup;
  step2Group: FormGroup;
  step3Group: FormGroup;
  step4Group: FormGroup;

  //Testting purpose
  createdOn: Date;
  details: any;
  testResources: any = [
    { text: "Security Camera Guidelines", url: "#" },
    { text: "Security Camera Vendors US & EU", url: "#" },
    { text: "Security Camera Vendors UK", url: "#" },
    { text: "Security Camera Vendors AP", url: "#" },
  ];
  globalApprovedHardware: "https://grsceqdev-h4a6g3gbgsh7hpe2.eastus-01.azurewebsites.net/view-national-equipments-standard-detail/f1331khislytryr3r72yr0wirf0id0fid0gd97g9d7gd9gd9un9crdfeua9t9n fgdfug98u9pguivun";

  showDependentStandardsItems: boolean = false;
  searchDependentStandardsTerm: string = "";
  selectedFromChild: any;

  prefilledNote = "<p>This is my prefilled note</p>";
  quillInstance: any;

  selectFromDepenedentStandard: any[] = [];
  selectedDependentStandardsMap = new Map<number, any>();
  showDependentDropdown: boolean = false;
  searched: boolean = false;

  firstFormGroup: FormGroup;
  get standardTypeEnum() {
    return StandardTypeEnum;
  }
  /** Step 0 shows every type to pick from when adding, but a standard's type
   *  isn't something you change by editing it - only show its own tile then. */
  get visibleStandardTypes() {
    if (this.grs?.standard?.id && this.standardTypes?.length) {
      return this.standardTypes.filter(
        (st) => st.id === this.grs.standard.standardTypeId,
      );
    }
    return this.standardTypes;
  }
  get StandardListType() {
    return StandardListType;
  }
  get categoryEnum() {
    return CategoryEnum;
  }
  get userRoleEnum() {
    return UserRoleEnum;
  }

  get selectedLocationNames(): string {
    return this.selectedLocations?.map((loc) => loc.name).join(", ") || "";
  }

  getUniqueElementsByKey(array, key) {
    const seen = new Map();

    return array.filter((item) => {
      const keyValue = item[key];

      if (seen.has(keyValue)) {
        return false;
      } else {
        seen.set(keyValue, true);

        return true;
      }
    });
  }

  constructor(
    // private _snackBar: MatSnackBar,
    private standardService: StandardService,
    private fb: FormBuilder,
    private activeRoute: ActivatedRoute,
    private router: Router,
    private ngbModal: NgbModal,
    private cryptographyService: CryptographyService,
    private SimpleModalService: SimpleModalService,
    private clipboard: Clipboard,
    private sanitizer: DomSanitizer,

    // private _formBuilder = inject(FormBuilder),
    private cdr: ChangeDetectorRef,
    @Inject(LOCAL_STORAGE) private storage: WebStorageService,
  ) {
    this.grs.standard.id = parseInt(
      this.activeRoute.snapshot.paramMap.get("grsId"),
    );
  }

  ngOnInit(): void {
    this.dropdownSettings = {
      singleSelection: false,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 6,
      allowSearchFilter: true,
    };
    this.categorydropdownSettings = {
      closeDropDownOnSelection: true,
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.subLocationdropdownSettings = {
      closeDropDownOnSelection: true,
      singleSelection: true,
      idField: "id",
      textField: "name",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 1,
      allowSearchFilter: true,
    };
    this.minimumStandardSettings = {
      singleSelection: false,
      idField: "id",
      textField: "title",
      selectAllText: "Select All",
      unSelectAllText: "UnSelect All",
      itemsShowLimit: 5,
      allowSearchFilter: true,
      closeDropDownOnSelection: false,
    };

    this.loading = true;
    this.createdOn = new Date();
    this.grs.standard.userId = this.cryptographyService.decryptData(
      this.storage.get("userId"),
    );
    if (this.grs.standard.id) {
      this.getGrbesDetailByGrbesId(this.grs.standard.id).subscribe(() => {
        this.setControlsValue();
      });
    }
    this.createForm();
    this.addLinks();
    this.minimumStandadControl.valueChanges
      .pipe(debounceTime(500))
      .subscribe((data) => {
        this.onMinimumStandadSearch(data);
        $(document).ready(() => {
          $(".input-equipment-menu").keyup(function () {
            $(".equipment-menu").parents("div").addClass("equipments");
          });
        });
      });
    this.addGrsForm.controls.minimumStandadId.valueChanges.subscribe((data) =>
      console.log("CHANGED IDS", this.addGrsForm.controls.minimumStandadId.value),
    );
  }

  /**
   * Create Form
   * @return void
   */
  createResourceLink(): FormGroup {
    return this.fb.group({
      url: [""],
      title: [""],
    });
  }

  addLinks() {
    this.resourceLinks1.push(this.createResourceLink());
  }
  removeLink(index: number): void {
    const linkGroup = this.resourceLinks1.at(index);

    if (linkGroup) {
      const url = linkGroup.get("url")?.value;
      const desc = linkGroup.get("title")?.value;
      if (url || desc) {
        linkGroup.get("url")?.setValue("");
        linkGroup.get("title")?.setValue("");
      } else {
        if (this.resourceLinks1.length > 1) {
          this.resourceLinks1.removeAt(index);
        }
      }
    }
    const hasInvalidRow = this.resourceLinks1.controls.some((link) => {
      const url = link.get("url")?.value;
      const title = link.get("title")?.value;
      return (url && !title) || (!url && title);
    });

    const ctrl = this.addGrsForm.get("linksFieldValid");

    if (hasInvalidRow) {
      ctrl?.setValidators(Validators.required);
    } else {
      ctrl?.clearValidators();
    }

    ctrl?.updateValueAndValidity();
  }
  pasteLink(link) {
    if (navigator.clipboard) {
      navigator.clipboard
        .readText()
        .then((text) => {
          if (text.includes("mcd.com")) {
            link.get("url").setValue(text);
            void 0;
            const url = link.get("url")?.value;
            const title = link.get("title")?.value;
            if (title && url) {
              this.addGrsForm.get("linksFieldValid")?.clearValidators();
              this.addGrsForm.get("linksFieldValid")?.updateValueAndValidity();
            } else {
              this.addGrsForm
                .get("linksFieldValid")
                ?.setValidators(Validators.required);
              this.addGrsForm.get("linksFieldValid")?.updateValueAndValidity();
            }
          } else {
            alert("not a valid URL");
          }
        })
        .catch((err) => {
          console.error("Failed to read clipboard: ", err);
        });
    } else {
      alert("Clipboard API not supported in this browser.");
    }
  }

  onEnterResourceTitle(link) {
    const url = link.get("url")?.value.trim();
    const title = link.get("title")?.value.trim();
    const ctrl = this.addGrsForm.get("linksFieldValid");
    if ((url && title) || (!url && !title)) {
      ctrl?.clearValidators();
    } else {
      ctrl?.setValidators(Validators.required);
    }

    ctrl?.updateValueAndValidity();
  }
  openLink(url: string) {
    if (url && url.trim() !== "") {
      const validUrl =
        url.startsWith("http://") || url.startsWith("https://") ? url : "";
      if (validUrl == "") {
        alert("Not a valid URL");
      } else {
        window.open(validUrl, "_blank");
      }
    } else {
      alert("No valid link provided!");
    }
  }
  get resourceLinks1() {
    return this.addGrsForm.get("resourceLinks1") as FormArray;
  }

  get hasResourceUrls(): boolean {
    return this.resourceLinks1.controls.some(
      (c) => !!c.get("url")?.value?.trim(),
    );
  }
  createForm(): void {
    let locationTypesArray = [];
    let categoriesArray = [];

    this.addGrsForm = this.fb.group({
      title: ["", Validators.required],
      description: ["", Validators.required],
      newrestaurantdescription: ["", Validators.required],
      note: ["", Validators.required],
      additionalInformation: [""],
      categoryId: ["", Validators.required],
      locationTypeId: ["", Validators.required],
      standardTypeId: [""],
      selectedStandardType: [""],
      subLocationTypeId: [""],
      effectiveFrom: [""],
      newRestaurantEffectiveFrom: [""],
      category: categoriesArray,
      minimumStandadId: [[]],
      locationType: locationTypesArray,
      keyContact: ["", [Validators.email]],
      keyContactDesc: [""],
      resourceLinks1: this.fb.array([]),
      linksFieldValid: [""],
    });

    this.step0Group = this.fb.group({
      standardTypeId: this.addGrsForm.get("standardTypeId"),
    });
    this.step1Group = this.fb.group({
      title: this.addGrsForm.get("title"),
      categoryId: this.addGrsForm.get("categoryId"),
      locationTypeId: this.addGrsForm.get("locationTypeId"),
      subLocationTypeId: this.addGrsForm.get("subLocationTypeId"),
    });
    this.step2Group = this.fb.group({
      description: this.addGrsForm.get("description"),
      newrestaurantdescription: this.addGrsForm.get("newrestaurantdescription"),
      minimumStandadId: this.addGrsForm.get("minimumStandadId"),
      // minimumStandadControl: this.minimumStandadControl,
    });

    this.step3Group = this.fb.group({
      note: this.addGrsForm.get("note"),
      linksFieldValid: this.addGrsForm.get("linksFieldValid"),
      // additionalInformation: this.addGrsForm.get("additionalInformation"),
      // resourceLinks: this.addGrsForm.get("resourceLinks1"),
    });
    this.step4Group = this.fb.group({
      keyContact: this.addGrsForm.get("keyContact"),
      // resourceLinks: this.addGrsForm.get("resourceLinks1"),
    });

    if (!this.grs.standard.id) {
      this.standardService
        .GetMasterDataForAddEditStandard(
          MasterDataRequestedType.AddGlobalStandard,
        )
        .subscribe((data: any) => {
          this.buildingCategories = data.buildingStandardCategories;

          if (this.selectedStandardType == "Operations Standards") {
            this.categoryDropdownList = data.operationsStandardsCategories;
          } else {
            this.categoryDropdownList = data.buildingStandardCategories;
          }
          this.operationsCategories = data.operationsStandardsCategories;
          this.LocationsdropdownList = data.locationTypes;

          void 0;
          this.locationTypes = data.locationTypes;
          this.standardTypes = data.standardTypes;
          void 0;
          this.grs.standard.imageAttachment.id = 0;
          this.grs.standard.imageFileName = null;
          this.grs.standard.imageAttachmentContentAsBase64 = null;
          this.grs.standard.imageAttachment.fileName = null;
          this.grs.standard.imageAttachment.attachmentContentAsBase64 = null;

          if (this.locationTypes != null) {
            this.locationTypes
              .sort((firstItem, nextItem) =>
                firstItem.name.localeCompare(nextItem.name),
              )
              .forEach((element) => {
                locationTypesArray.push(
                  this.fb.group({
                    id: new FormControl(element.id),
                    name: new FormControl(element.name),
                  }),
                );
              });
          }
          this.loading = false;
        });
    }
  }

  onChangeStandardType(standardTypeId: number) {
    this.grs.standard.standardTypeId = standardTypeId;

    // Keeps the review page's type-driven sections (Dependent Standards,
    // Category source) correct when a standard is loaded for edit, since
    // selectStandard() - the only other place this was set - never runs
    // outside the interactive "pick a type" tile click in the add flow.
    const matchedType = this.standardTypes?.find(
      (st) => st.id === standardTypeId,
    );
    if (matchedType) {
      this.selectedStandardType = matchedType.name;
    }

    if (
      this.grs.standard.standardTypeId ==
      this.standardTypeEnum.GlobalMinimumRestaurantStandard ||
      this.grs.standard.standardTypeId ==
      this.standardTypeEnum.OperationsStandards
    ) {
      this.globalstandards = true;
      this.minimumStandadControl.setValidators(null);
      this.minimumStandadControl.updateValueAndValidity();
      this.addGrsForm.controls.minimumStandadId.setValidators(null);
      this.addGrsForm.controls.minimumStandadId.updateValueAndValidity();
      this.addGrsForm.controls.locationTypeId.setValidators(
        Validators.required,
      );
      this.addGrsForm.controls.locationTypeId.updateValueAndValidity();
      this.addGrsForm.controls.categoryId.setValidators(Validators.required);
      this.addGrsForm.controls.categoryId.updateValueAndValidity();

      if (!this.grs.standard.id) {
        this.addGrsForm.controls.effectiveFrom.setValue(new Date());
        this.addGrsForm.controls.newRestaurantEffectiveFrom.setValue(
          new Date(),
        );
      }
    } else {
      this.globalstandards = false;
      this.minimumStandadControl.setValidators(Validators.required);
      this.minimumStandadControl.updateValueAndValidity();
      this.addGrsForm.controls.minimumStandadId.setValidators(
        Validators.required,
      );
      this.addGrsForm.controls.minimumStandadId.updateValueAndValidity();
      this.addGrsForm.controls.locationTypeId.setValidators(null);
      this.addGrsForm.controls.locationTypeId.updateValueAndValidity();
      this.addGrsForm.controls.categoryId.setValidators(null);
      this.addGrsForm.controls.categoryId.updateValueAndValidity();
      if (!this.grs.standard.id) {
        this.addGrsForm.controls.effectiveFrom.setValue(new Date());
        this.addGrsForm.controls.newRestaurantEffectiveFrom.setValue(
          new Date(),
        );
      }
    }
  }

  getMinimumStandardsForSearchAfterLoading(x) {
    let latestSearchIds = this.latestSearchResults.map((o) => o.id);
    let selectedIds = this.addGrsForm.controls.minimumStandadId.value.map(
      (o) => o.id,
    );
    const minimumResults = x.filter(
      (o) => latestSearchIds.includes(o.id) || selectedIds.includes(o.id),
    );
    void 0;
    return minimumResults;
  }
  onMinimumStandadSearch(searchkey): any {
    this.latestSearchResults = [];

    void 0;
    if (searchkey) {
      this.searchDependentStandardsTerm = searchkey;

      if (searchkey.length > 2) {
        this.searched = true;

        this.minimumStandardsLoading = true;
        this.minimumStandards = []; // Clear previous results while loading
        this.standardService
          .getMinimumStandardsBySearchKey(searchkey)
          .subscribe((data: any) => {
            data.forEach((o) => {
              this.minimumStandads.push(o);
              this.latestSearchResults.push(o);
            });
            const minimunResults =
              this.getMinimumStandardsForSearchAfterLoading(
                this.minimumStandads,
              );

            void 0;
            this.minimumStandards = minimunResults;
            // console.log("drop", this.minimumStandards)

            this.minimumStandads = this.getUniqueElementsByKey(
              this.minimumStandads,
              "id",
            );
            void 0;

            // console.log(
            //   "EQUALITY COMPARISON",
            //   this.minimumStandads[0] ==
            //     this.addGrsForm.controls.minimumStandadId.value[0],
            // );
            this.minimumStandardsLoading = false;
          });
      }
    }
  }
  showSublocationField() {
    try {
      if (this.step1Group.get("locationTypeId")?.value) {
        const result = this.step1Group.get("locationTypeId")?.value;
        if (result.includes(8)) {
          return true;
        }
      }
    } catch (error) {
      return false;
    }
  }

  //getAllCategories(): void {
  //  this.loading = true;
  //  this.standardService.getAllCategories()
  //    .subscribe(
  //      (data: Category[]) => {
  //        this.categories = data.map(o => new Category(o));
  //        this.loading = false;
  //      });
  //}

  setLocationCategoryMapping(locationType) {
    this.addGrsForm.controls.locationTypeId.reset();
    this.addGrsForm.controls.locationTypeId.setValue(locationType);
    void 0;
    if (
      this.grs.standard.standardTypeId ==
      this.standardTypeEnum.OperationsStandards ||
      this.grs.standard.standardTypeId ==
      this.standardTypeEnum.GlobalMinimumRestaurantStandard
    ) {
      this.setSublocationsAndSublocationsvalidations(locationType);
    }
  }

  setCategory(category) {
    this.addGrsForm.controls.categoryId.setValue(category);
  }

  getAllLocationTypes(): void {
    this.standardService
      .getAllLocationTypes()
      .subscribe((data: LocationType[]) => {
        this.locationTypes = data.map((o) => new LocationType(o));
      });
  }

  getAllStandardTypes(): void {
    this.standardService
      .getAllStandardTypes(true, false)
      .subscribe((data: StandardType[]) => {
        this.standardTypes = data.map((o) => new StandardType(o));
      });
  }

  getStandardType(id) {
    let stdTypeNameMap = {
      1: "Obsolete Standard",
      2: "Building Standard",
      3: "Upcoming Standard",
      4: "Global Equipment Standard",
      5: "Market Equipment Standard",
      6: "Market Standard",
      7: "Location Standard",
      8: "Dependent Standard",
      9: "Global Approved Solution",
      10: "Shared Learnings and Recommendations",
      11: "Operations Standards",
    };
    return stdTypeNameMap[id];
  }

  startTimer() {
    this.startTime = new Date();
    // alert("timer started");
  }
  endTimer() {
    if (!this.startTime) {
      console.error("Start time is not set.");
      return;
    }
    this.endTime = new Date();
    const timeDiff = this.endTime.getTime() - this.startTime.getTime();
    const seconds = timeDiff / 1000;
    // alert("timer stopped");

    return seconds;
  }
  saveGrbes(): void {
    this.startTimer();
    this.newCreatedStandard = [];

    const isCtrlValid = (ctrl) => !ctrl || ctrl.valid || ctrl.disabled;

    const isEssentialValid =
      isCtrlValid(this.addGrsForm.controls.title) &&
      isCtrlValid(this.addGrsForm.controls.description) &&
      isCtrlValid(this.addGrsForm.controls.newrestaurantdescription) &&
      isCtrlValid(this.addGrsForm.controls.note);

    if (!isEssentialValid) {
      Object.keys(this.addGrsForm.controls).forEach((key) => {
        const control = this.addGrsForm.get(key);
        if (control && control.invalid && !control.disabled) {
          console.warn(`Invalid control on submit: ${key}`, control.errors);
          control.markAsTouched();
        }
      });
      alert("Please fill out all required fields before submitting.");
      return;
    }

    this.grs.standard.standardTypeId =
      this.addGrsForm.controls.standardTypeId.value;
    this.grs.standard.title =
      this.addGrsForm.controls.title.value || this.grs.standard.title;
    this.grs.standard.description =
      this.addGrsForm.controls.description.value;
    this.grs.standard.newRestaurantDescription =
      this.addGrsForm.controls.newrestaurantdescription.value;
    this.grs.standard.userId = this.cryptographyService.decryptData(
      this.storage.get("userId"),
    );
    this.grs.standard.note = this.addGrsForm.controls.note.value;
    this.grs.standard.additionalInformation =
      this.addGrsForm.controls.additionalInformation.value;

    const links = this.addGrsForm.controls.resourceLinks1.value;

    this.grs.standard.links = links.filter(
      (link) => link.url?.trim() || link.title?.trim(),
    );
    this.grs.standard.keyContact = {
      email: this.addGrsForm.controls.keyContact.value,
      emailDescription: this.addGrsForm.controls.keyContactDesc.value,
    };
    this.grs.standard.effectiveFrom =
      this.addGrsForm.controls.effectiveFrom.value != null
        ? this.onBuildDateString(
          new Date(this.addGrsForm.controls.effectiveFrom.value)
            .toLocaleDateString("en-US")
            .replace(/\u200E/g, ""),
        )
        : null;
    this.grs.standard.newRestaurantsEffectiveFrom =
      this.addGrsForm.controls.newRestaurantEffectiveFrom.value != null
        ? this.onBuildDateString(
          new Date(
            this.addGrsForm.controls.newRestaurantEffectiveFrom.value,
          )
            .toLocaleDateString("en-US")
            .replace(/\u200E/g, ""),
        )
        : null;

    const minStdValue = this.addGrsForm.controls.minimumStandadId.value;
    const hasMinStdValue = Array.isArray(minStdValue) && minStdValue.length > 0;

    if (
      this.grs.standard.standardTypeId ==
      this.standardTypeEnum.GlobalMinimumRestaurantStandard ||
      this.grs.standard.standardTypeId ==
      this.standardTypeEnum.OperationsStandards
    ) {
      if (
        this.grs.standard.standardTypeId ==
        this.standardTypeEnum.OperationsStandards
      ) {
        this.grs.standard.imageFileName =
          this.grs.standard.imageAttachment.fileName;
        this.grs.standard.subLocationTypeId = this.addGrsForm.controls
          .subLocationTypeId
          ? this.addGrsForm.controls.subLocationTypeId.value
          : null;
      }

      this.grs.standard.categoryId =
        this.addGrsForm.controls.categoryId.value;
      this.grs.standard.locationTypeId =
        this.addGrsForm.controls.locationTypeId.value;
    } else {
      if (!this.grs.standard.dependentStandard) {
        this.grs.standard.dependentStandard = {
          DependentStandId: 0,
          Id: 0,
          MinimumStandId: 0,
          Title: null,
        };
      }
      if (hasMinStdValue) {
        this.grs.standard.dependentStandard.minimumStandadId = minStdValue[0];
      }

      // BU Standards / Global Approved Solution have no Category or Location
      // field of their own in this wizard (see "globalstandards" above) - they
      // inherit both from the dependent Minimum/Operations Standard, same as
      // CreateStandardCommandHandler already does server-side. Mirroring that
      // here matters for UpdateStandardCommandHandler, which - unlike create -
      // writes CategoryId/LocationTypeId from the payload unconditionally with
      // no dependent-standard fallback, so leaving these unset would silently
      // null them out on every edit.
      const selectedDependentStandard = this.selectFromDepenedentStandard?.[0];
      if (selectedDependentStandard) {
        this.grs.standard.categoryId = selectedDependentStandard.category?.id;
        this.grs.standard.locationTypeId =
          selectedDependentStandard.locationType?.id;
      }
    }

    if (this.grs.standard.id) {
      this.updateAGrbes(this.grs.standard).subscribe((data) => {
        this.newCreatedStandard.push({
          name: this.grs.standard.title,
          totalTime: this.endTimer(),
          eventType: "NewStandards",
          status: "Modified",
          standardType: "GlobalStandard",
          session: JSON.parse(localStorage.getItem("NRBA_SESSION") || "{}")?.value || null,
          error: this.error,
          errorMessage: "No error",
        });
        const modalRef = this.ngbModal.open(SuccessDialogComponent);
        modalRef.componentInstance.message = data.message;
        if (data == false) {
          modalRef.componentInstance.title = "Error";
          modalRef.componentInstance.message =
            "Some error occurred. Please try again after some time";
        }
        modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
          this.ngbModal.dismissAll();
          if (
            this.grs.standard.standardTypeId ==
            this.standardTypeEnum.OperationsStandards
          ) {
            this.router.navigate(["/view-all-standards"]);
          } else {
            this.onBackClickorEditRedirect();
          }
        });
        this.reset();
      });
    } else {
      this.grs.standard.id = 0;

      if (hasMinStdValue) {
        this.grs.standard.dependentStandard = {
          minimumStandadId: minStdValue[0],
        };
        this.grs.standard.dependentStandards = minStdValue;
      } else {
        this.grs.standard.dependentStandard = {
          DependentStandId: 0,
          Id: 0,
          MinimumStandId: 0,
          Title: null,
        };
        this.grs.standard.dependentStandards = null;
      }

      this.addAGrbes(this.grs.standard).subscribe((data) => {
        const modalRef = this.ngbModal.open(SuccessDialogComponent);
        this.newCreatedStandard.push({
          name: this.grs.standard.title,
          totalTime: this.endTimer(),
          eventType: "NewStandards",
          status: "Created",
          standardType: "GlobalStandard",
          session: JSON.parse(localStorage.getItem("NRBA_SESSION") || "{}")?.value || null,
          error: this.error,
          errorMessage: "No error",
        });
        void 0;
        this.standardService
          .recordEvent(this.newCreatedStandard)
          .subscribe({ next: () => void 0, error: () => void 0 });

        modalRef.componentInstance.message = data.message;
        if (data == false) {
          modalRef.componentInstance.title = "Error";
          modalRef.componentInstance.message =
            "Some error occurred. Please try again after some time";
        }
        if (data.Status == false) {
          modalRef.componentInstance.title = "Error";
          modalRef.componentInstance.message =
            "Some error occurred. Please try again after some time";
        }

        modalRef.componentInstance.nrbesSuccessPopupEmit.subscribe(() => {
          this.ngbModal.dismissAll();
          if (data.status) {
            this.isSuccessfull = true;
            const isUpcoming =
              (this.grs.standard.effectiveFrom &&
                new Date(this.grs.standard.effectiveFrom) > new Date()) ||
              (this.grs.standard.newRestaurantsEffectiveFrom &&
                new Date(this.grs.standard.newRestaurantsEffectiveFrom) >
                  new Date());
            if (isUpcoming) {
              this.standardService.upcomingStandardFiltration.searchKey = "";
              this.standardService.upcomingStandardFiltration.startingIndex = 1;
            } else {
              this.standardService.allStandardsFiltration.searchKey = "";
              this.standardService.allStandardsFiltration.startingIndex = 1;
            }
            this.router.navigate([
              isUpcoming
                ? "/view-all-upcoming-standards-list"
                : "/view-all-standards",
            ]);
            this.reset();
          } else {
            this.isSuccessfull = false;
            this.stepper.selected.completed = false;
            if (this.stepper) {
              this.stepper.previous(); // Go to the previous step on error
            }
            setTimeout(() => {
              this.stepper.selectedIndex = 5; // move to step 1
              const steps = this.stepper.steps.toArray();
              steps[5].completed = false; // reset last step
            }, 0);
          }
        });
      });
    }
  }

  getGrbesDetailByGrbesId(grbesId: number): Observable<boolean> {
    this.loading = true;
    return new Observable<boolean>((observer) => {
      this.standardService
        .getStandardInfomationByStandardId(grbesId)
        .subscribe((data: SelectedStandard) => {
          this.grs = new SelectedStandard(data);

          // Edit mode previously only ever pushed this standard's own
          // category/location/type into otherwise-empty lists, so the
          // dropdowns showed just the one value picked at creation time with
          // nothing else to choose from. Fetch the same full master data the
          // add flow uses, so editing offers every option, not just the
          // current one.
          this.standardService
            .GetMasterDataForAddEditStandard(
              MasterDataRequestedType.AddGlobalStandard,
            )
            .subscribe((masterData: any) => {
              this.buildingCategories = masterData.buildingStandardCategories || [];
              this.operationsCategories = masterData.operationsStandardsCategories || [];
              this.locationTypes = masterData.locationTypes || [];
              this.standardTypes = masterData.standardTypes || [];

              this.categoryDropdownList =
                this.grs.standard.standardTypeId ===
                this.standardTypeEnum.OperationsStandards
                  ? this.operationsCategories
                  : this.buildingCategories;
              this.LocationsdropdownList = this.locationTypes;

              // Defensive: keep this standard selectable even if its current
              // category/location was deactivated/removed since it was created.
              if (
                this.grs.standard.category &&
                !this.categoryDropdownList.some(
                  (c) => c.id === this.grs.standard.category.id,
                )
              ) {
                this.categoryDropdownList = [
                  this.grs.standard.category,
                  ...this.categoryDropdownList,
                ];
              }
              if (
                this.grs.standard.locationType &&
                !this.LocationsdropdownList.some(
                  (l) => l.id === this.grs.standard.locationType.id,
                )
              ) {
                this.LocationsdropdownList = [
                  this.grs.standard.locationType,
                  ...this.LocationsdropdownList,
                ];
              }

              this.selectedCategory = [this.grs.standard.category];
              this.selectedLocations = [this.grs.standard.locationType];

              if (this.grs.standard.locationType.subLocationTypes.length > 0) {
                this.subLocationTypes.push(this.grs.standard.subLocationType);
              }

              this.loading = false;
              observer.next(true);
            });
        });
    });
  }

  addAGrbes(standard: Standard): Observable<any> {
    this.loading = true;
    return new Observable<any>((observer) => {
      this.standardService.addStandard(standard).subscribe(
        (data: any) => {
          this.loading = false;
          observer.next(data);
        },
        (error) => {
          this.loading = false;
          this.newCreatedStandard.push({
            name: this.grs.standard.title,
            totalTime: this.endTimer(),
            eventType: "NewStandards",
            status: "Failed",
            standardType: "GlobalStandard",
            session: JSON.parse(localStorage.getItem("NRBA_SESSION") || "{}")?.value || null,
            error: true,
            errorMessage: error.message,
          });
          void 0;
          this.standardService
            .recordEvent(this.newCreatedStandard)
            .subscribe({ next: () => void 0, error: () => void 0 });
          observer.next(false);
        },
      );
    });
  }

  updateAGrbes(standard: Standard): Observable<any> {
    this.loading = true;
    return new Observable<any>((observer) => {
      this.standardService.updateStandard(standard).subscribe(
        (data: any) => {
          this.loading = false;
          observer.next(data);
        },
        (error) => {
          this.loading = false;
          this.newCreatedStandard.push({
            name: this.grs.standard.title,
            totalTime: this.endTimer(),
            eventType: "NewStandards",
            status: "Failed",
            standardType: "GlobalStandards",
            session: JSON.parse(localStorage.getItem("NRBA_SESSION") || "{}")?.value || null,
            error: true,
            errorMessage: error.message,
          });
          void 0;
          this.standardService
            .recordEvent(this.newCreatedStandard)
            .subscribe({ next: () => void 0, error: () => void 0 });
          observer.next(false);
        },
      );
    });
  }

  reset() {
    this.addGrsForm.controls.title.reset();
    this.addGrsForm.controls.note.reset();
    this.addGrsForm.controls.additionalInformation.reset();
    this.addGrsForm.controls.description.reset();
    this.addGrsForm.controls.newrestaurantdescription.reset();
    this.addGrsForm.controls.effectiveFrom.reset();
    this.addGrsForm.controls.locationTypeId.reset();
    this.addGrsForm.controls.locationTypeId.setValue(null);
    this.addGrsForm.controls.categoryId.reset();
    this.addGrsForm.controls.categoryId.setValue(null);
    this.addGrsForm.controls.standardTypeId.reset();
    this.addGrsForm.controls.standardTypeId.setValue(null);
    this.addGrsForm.controls.minimumStandadId.reset();
    this.addGrsForm.controls.effectiveFrom.reset();
    this.addGrsForm.controls.newRestaurantEffectiveFrom.reset();
    this.minimumStandadControl.reset();
    this.buildingCategories = [];
    this.operationsCategories = [];

    this.grs.standard.imageAttachment.fileName = null;
    this.grs.standard.imageAttachment.attachmentContentAsBase64 = null;
    this.grs.standard.imageFileName = null;
    this.grs.standard.imageAttachmentContentAsBase64 = null;
    this.invalidImage = false;
    this.createForm();
  }

  setControlsValue() {
    this.addGrsForm.controls.locationTypeId.setValue(
      this.grs.standard.locationType.id,
    );
    this.categoryForLastPage = this.grs.standard.category.name;
    // BU Standards / Global Approved Solution read their review-page category
    // from dependentcategories instead of categoryForLastPage - keep both in
    // sync here since edit mode never recomputes dependentcategories from a
    // live dependent-standard selection the way the add flow does.
    this.dependentcategories = this.grs.standard.category.name;
    this.addGrsForm.controls.categoryId.setValue(this.grs.standard.category.id);
    this.addGrsForm.controls.standardTypeId.setValue(
      this.grs.standard.standardTypeId,
    );
    this.addGrsForm.controls.title.setValue(this.grs.standard.title);
    this.addGrsForm.controls.title.disable();
    // The dependent standard is now editable, not locked - do not disable
    // minimumStandadControl here.
    this.minimumStandadControl.setValue(
      this.grs.standard.dependentStandard.title,
    );

    this.addGrsForm.controls.description.setValue(
      this.grs.standard.description,
    );
    this.addGrsForm.controls.newrestaurantdescription.setValue(
      this.grs.standard.newRestaurantDescription,
    );
    const note = DOMPurify.sanitize(this.grs.standard.note);
    this.addGrsForm.controls.note.setValue(note);
    const additionalInformation = DOMPurify.sanitize(
      this.grs.standard.additionalInformation,
    );
    this.addGrsForm.controls.additionalInformation.setValue(
      additionalInformation,
    );

    if (this.grs.standard.effectiveFrom != null) {
      this.addGrsForm.controls.effectiveFrom.setValue(
        new Date(this.grs.standard.effectiveFrom),
      );
    } else {
      this.addGrsForm.controls.effectiveFrom.setValue(
        this.grs.standard.effectiveFrom,
      );
    }

    if (this.grs.standard.newRestaurantsEffectiveFrom != null) {
      this.addGrsForm.controls.newRestaurantEffectiveFrom.setValue(
        new Date(this.grs.standard.newRestaurantsEffectiveFrom),
      );
    } else {
      this.addGrsForm.controls.newRestaurantEffectiveFrom.setValue(
        this.grs.standard.newRestaurantsEffectiveFrom,
      );
    }

    // dependentStandard.id is the join row's own id, not the minimum/operations
    // standard it points at - saveGrbes() reads minimumStandadId's value back out
    // as "which standard(s) this depends on" (dependentStandard.minimumStandadId =
    // minStdValue[0]), so using .id here would silently repoint the dependency to
    // the wrong standard on the next save.
    const dependentStandardId = this.grs.standard.dependentStandard.minimumStandadId;
    this.addGrsForm.controls.minimumStandadId.setValue([dependentStandardId]);

    // The chip/review display reads selectFromDepenedentStandard, which (unlike
    // minimumStandadId) is never populated by loading a standard for edit - only
    // by the interactive search used when adding. Fetch the full dependent
    // standard so edit mode can actually show what this standard depends on.
    if (dependentStandardId) {
      this.standardService
        .getStandardInfomationByStandardId(dependentStandardId)
        .subscribe((dependentData: any) => {
          const dependentStandardDetail = dependentData?.standard;
          if (dependentStandardDetail) {
            this.selectItem(true, dependentStandardDetail);
          }
        });
    }

    this.onChangeStandardType(this.grs.standard.standardTypeId);

    if (this.grs.standard.locationType.subLocationTypes.length > 0) {
      this.subLocationTypes.push(this.grs.standard.subLocationType);
      this.addGrsForm.controls.subLocationTypeId.setValue(
        this.grs.standard.subLocationTypeId,
      );
    }

    // Prefill Key Contact (email and description)
    const rawKeyContact =
      this.grs.keyContact ||
      (this.grs as any).KeyContact ||
      this.grs.standard?.keyContact ||
      (this.grs.standard as any)?.KeyContact;

    let email = "";
    let emailDesc = "";

    if (rawKeyContact) {
      if (typeof rawKeyContact === "string") {
        email = rawKeyContact;
      } else if (typeof rawKeyContact === "object") {
        email = rawKeyContact.email || rawKeyContact.Email || "";
        emailDesc = rawKeyContact.emailDescription || rawKeyContact.EmailDescription || "";
      }
    }
    if (!email) {
      email = (this.grs as any).email || (this.grs as any).Email || this.grs.standard?.email || (this.grs.standard as any)?.Email || "";
    }
    if (!emailDesc) {
      emailDesc = (this.grs as any).emailDescription || (this.grs as any).EmailDescription || this.grs.standard?.emailDescription || (this.grs.standard as any)?.EmailDescription || (this.grs.standard as any)?.keyContactDesc || "";
    }

    if (this.addGrsForm.controls.keyContact) {
      this.addGrsForm.controls.keyContact.setValue(email);
    }
    if (this.addGrsForm.controls.keyContactDesc) {
      this.addGrsForm.controls.keyContactDesc.setValue(emailDesc);
    }

    // Prefill Resource Links
    const linksList =
      this.grs.links ||
      (this.grs as any).Links ||
      this.grs.standard?.links ||
      (this.grs.standard as any)?.Links;

    if (Array.isArray(linksList) && linksList.length > 0) {
      while (this.resourceLinks1.length > 0) {
        this.resourceLinks1.removeAt(0);
      }
      linksList.forEach((link: any) => {
        const title = link.title ?? link.Title ?? link.name ?? "";
        const url = link.url ?? link.Url ?? "";
        this.resourceLinks1.push(
          this.fb.group({
            url: [url],
            title: [title],
          })
        );
      });
    }
  }

  onBackClickorEditRedirect() {
    this.router.navigate([this.standardService.standardEditPreviousRoute]);
  }

  onBuildDateString(date: string) {
    let partsArray = date.split("/");
    let buildedDate = "";
    partsArray.forEach((x) => {
      if (x.length == 1 || x.length == 2) {
        if (x.length == 1) {
          buildedDate += ("0" + x).slice(-2) + "/";
        } else {
          buildedDate += x + "/";
        }
      } else {
        buildedDate += x;
      }
    });
    return buildedDate;
  }

  setSubLocation(subLocationType) {
    this.addGrsForm.controls.subLocationTypeId.reset();
    this.addGrsForm.controls.subLocationTypeId.setValue(subLocationType);
  }

  setSublocationsAndSublocationsvalidations(locationType) {
    void 0;
    const kitchen = this.locationTypes.find((p) => p.name === "Kitchen");

    if (kitchen && locationType.includes(kitchen.id)) {
      this.subLocationTypes = kitchen.subLocationTypes;
      this.sublocationDropdownList = this.subLocationTypes;
      void 0;
    } else {
      this.subLocationTypes = [];
      this.sublocationDropdownList = [];
      this.subLocationselected = [];
    }

    if (this.subLocationTypes.length > 0) {
      this.addGrsForm.controls.subLocationTypeId.setValidators(
        Validators.required,
      );
      this.addGrsForm.controls.subLocationTypeId.updateValueAndValidity();
    } else {
      this.addGrsForm.controls.subLocationTypeId.setValidators(null);

      this.addGrsForm.controls.subLocationTypeId.updateValueAndValidity();
    }
  }

  onRemoveImage() {
    this.grs.standard.imageAttachment.id = 0;
    this.grs.standard.imageFileName = null;
    this.grs.standard.imageAttachmentContentAsBase64 = null;
    this.grs.standard.imageAttachment.fileName = null;
    this.grs.standard.imageAttachment.attachmentContentAsBase64 = null;
    this.invalidImage = false;
    this.invalidImageRes = false;
  }

  onDownloadSelectedImage(id) {
    if (id) {
      return this.standardService.getAttachmentUrl(id, false).subscribe(
        (response: any) => {
          const blob = new Blob([response], {
            type: response.type,
          });
          if (
            (window.navigator as any) &&
            (window.navigator as any).msSaveOrOpenBlob
          ) {
            (window.navigator as any).msSaveOrOpenBlob(blob);
            return;
          }
          const url = window.URL.createObjectURL(blob);
          window.open(url);
        },
        (error: any) => {
          const modalRef = this.ngbModal.open(FailModuleComponent);
          modalRef.componentInstance.errorMessage = error.error
            ? error.error.Message
            : error.message;
        },
      );
    } else {
      fetch(this.grs.standard.imageAttachmentContentAsBase64)
        .then((res) => res.blob())
        .then((blob) => {
          if ((window.navigator as any).msSaveOrOpenBlob) {
            (window.navigator as any).msSaveBlob(
              blob,
              this.grs.standard.imageAttachment.fileName,
            );
          } else {
            var a = document.createElement("a");
            a.href = this.grs.standard.imageAttachmentContentAsBase64;
            a.setAttribute(
              "download",
              this.grs.standard.imageAttachment.fileName,
            );
            a.click();
          }
        });
    }
  }

  onSelectImage(event) {
    this.invalidImageRes = false;
    let selectedFile = event.target.files[0];
    this.imageChangedEvent = event.target.files[0];
    this.invalidImage = this.validateFileType(selectedFile.name);
    if (!this.invalidImage) {
      this.showPrompt().then((result) => {
        void 0;
        if (result == null) {
          this.grs.standard.imageAttachmentContentAsBase64 = null;
          event.target.value = null;
          this.grs.standard.imageAttachment.fileName = null;
        } else {
          this.grs.standard.imageAttachmentContentAsBase64 = result;
          event.target.value = null;
          this.grs.standard.imageAttachment.fileName = selectedFile.name;
        }
      });
    }
  }

  validateFileType(fileName: string) {
    let fileTypeArr = ["jpg", "jpeg", "png", "bmp"];
    if (fileName != null) {
      let fileNameArr = [];
      let splitedFileName = fileName.toLowerCase().split(".");
      splitedFileName.forEach(function (obj) {
        fileNameArr.push(obj);
      });
      fileNameArr = fileNameArr.reverse();
      if (!fileTypeArr.includes(fileNameArr[0])) {
        return true;
      }
      return false;
    }
  }

  validateImageResolution(selectedFile, status): Observable<boolean> {
    return new Observable<boolean>((observer) => {
      if (status == false) {
        var url = URL.createObjectURL(selectedFile);
        var img = new Image();
        img.onload = function () {
          if (img.width != img.height) {
            observer.next(true);
          }
        };
        img.src = url;
      }
    });
  }

  showPrompt(): Promise<string> {
    return new Promise<string>((resolve) => {
      this.SimpleModalService.addModal(ModalImageCropperComponent, {
        title: "Crop your image",
        ratio: 1,
        event: this.imageChangedEvent,
      }).subscribe((image) => {
        resolve(image);
      });
    });
  }

  onPasteCleanup(fieldNmae: string) {
    setTimeout(() => {
      const ctrl = this.addGrsForm.get(fieldNmae);
      if (!ctrl) return;

      const cleaned = (ctrl.value || "")
        .replace(/[\u00A0\u2000-\u200B]/g, " ")
        .replace(/\s{2,}/g, "  ");

      if (ctrl.value !== cleaned) {
        ctrl.setValue(cleaned, { emitEvent: false });
      }
    }, 0);
  }

  cleanQuillHTML(html: string): string {
    return (
      html
        .replace(/\u00A0|\u202F/g, " ")
        .replace(/\uFEFF/g, "")
        // .replace(/\u200B/g, '')         // Remove zero-width space
        // .replace(/\s+/g, ' ')           // Collapse multiple spaces if needed
        // .replace(/<span[^>]*>(\s*)<\/span>/g, '$1') // Remove empty spans
        .trim()
    );
  }

  //on editor created
  onEditorCreated(quill: any, quillType: string) {
    this.quillInstance = quill;
    const value = this.addGrsForm.get(quillType)?.value;
    if (value) {
      quill.clipboard.dangerouslyPasteHTML(value);
    }
    quill.root.addEventListener("paste", (event: ClipboardEvent) => {
      const pastedText = event.clipboardData?.getData("text/plain");
      const pastedHtml = event.clipboardData?.getData("text/html");

      // void 0;
      // void 0;
      if (pastedHtml) {
        event.preventDefault();

        const cleanHtml = this.cleanQuillHTML(pastedHtml);
        const delta = quill.clipboard.convert(cleanHtml);

        quill.updateContents(delta, "user");
      }
    });
  }

  handleStandardSelection(name: string, id: number, stepper: MatStepper): void {
    this.selectStandard(name, id);

    const control = this.addGrsForm.get("standardTypeId");
    if (control) {
      control.markAsTouched();
      control.updateValueAndValidity();

      if (control.valid) {
        stepper.next();
        this.nextStep();
      } else {
        console.warn("standardTypeId is invalid.");
      }
    }
  }

  selectStandard(standard: string, id: number) {
    const control = this.addGrsForm.get("standardTypeId");
    control.setValue(id);
    control.markAsTouched();
    this.selectedStandardType = standard;
  }

  onStepChange(event: StepperSelectionEvent): void {
    if (event.selectedIndex === 0) {
      this.selectedStandardType = null;

      // this.currentStepIndex = 0
    }

    // this.currentStepIndex = event.selectedIndex;
  }

  copyDescriptionToExisting(isChecked: boolean): void {
    const newDesc =
      this.addGrsForm.get("newrestaurantdescription")?.value || "";
    const descControl = this.addGrsForm.get("description");

    if (isChecked && this.addGrsForm.get("newrestaurantdescription")?.value) {
      this.descriptionChecked = isChecked;
      descControl?.setValue(newDesc);
      // descControl?.disable();
    } else {
      this.descriptionChecked = false;
      // descControl?.enable();
      descControl?.reset();
    }
  }

  nextStep(): void {
    void 0;
    if (this.currentStepIndex == 1) {
      if (this.step1Group.get("title")?.invalid) {
        this.step1Group.get("title")?.markAsTouched();
        this.addGrsForm.get("title")?.markAsTouched();
      }

      if (this.globalstandards) {
        this.step1Group.get("categoryId")?.markAsTouched();
        this.addGrsForm.get("categoryId")?.markAsTouched();
        this.step1Group.get("locationTypeId")?.markAsTouched();
        this.addGrsForm.get("locationTypeId")?.markAsTouched();
      }

      if (this.step1Group.get("subLocationTypeId")?.invalid) {
        this.step1Group.get("subLocationTypeId")?.markAsTouched();
      }

      const isTitleInvalid =
        this.step1Group.get("title")?.invalid ||
        !this.addGrsForm.get("title")?.value?.trim();
      const isCategoryInvalid =
        this.globalstandards &&
        (this.step1Group.get("categoryId")?.invalid ||
          this.addGrsForm.get("categoryId")?.invalid ||
          !this.addGrsForm.get("categoryId")?.value);
      const isLocationInvalid =
        this.globalstandards &&
        (this.step1Group.get("locationTypeId")?.invalid ||
          !this.addGrsForm.get("locationTypeId")?.value ||
          (Array.isArray(this.addGrsForm.get("locationTypeId")?.value) &&
            this.addGrsForm.get("locationTypeId")?.value.length === 0));
      const isSublocationInvalid =
        this.showSublocationField() &&
        this.step1Group.get("subLocationTypeId")?.invalid;

      if (
        isTitleInvalid ||
        isCategoryInvalid ||
        isLocationInvalid ||
        isSublocationInvalid
      ) {
        return;
      }
    }

    if (this.currentStepIndex == 2) {
      if (this.step2Group.get("minimumStandadControl")?.invalid) {
        this.step2Group.get("minimumStandadControl")?.markAsTouched();
      }
      if (this.step2Group.get("minimumStandadId")?.invalid) {
        this.step2Group.get("minimumStandadId")?.markAsTouched();
      }
      if (this.step2Group.get("description")?.invalid) {
        this.step2Group.get("description")?.markAsTouched();
      }

      if (this.step2Group.get("newrestaurantdescription")?.invalid) {
        this.step2Group.get("newrestaurantdescription")?.markAsTouched();
      }

      if (this.step2Group.invalid) {
        return;
      }
    }

    if (this.currentStepIndex == 3) {
      if (this.step3Group.get("note")?.invalid) {
        this.step3Group.get("note")?.markAsTouched();
      }
      if (this.step3Group.get("linksFieldValid")?.invalid) {
        this.step3Group.get("linksFieldValid")?.markAsTouched();
      }
      if (this.step3Group.invalid) {
        return;
      }
    }
    if (this.currentStepIndex === 4) {
      const emailCtrl = this.step4Group.get("keyContact");

      if (emailCtrl?.invalid) {
        emailCtrl.markAsTouched();
        return;
      }
    }

    if (this.currentStepIndex <= this.formSteps.length - 1) {
      this.formSteps[this.currentStepIndex].status = "completed";
      this.currentStepIndex++;
      this.formSteps[this.currentStepIndex].status = "active";
    }
  }

  previousStep(): void {
    // alert(this.currentStepIndex);

    if (this.currentStepIndex > 0) {
      this.formSteps[this.currentStepIndex].status = "inactive";
      this.currentStepIndex--;
      this.formSteps[this.currentStepIndex].status = "active";
    }
  }

  goToStep(targetIndex: number, event: StepperSelectionEvent): void {
    if (targetIndex === this.currentStepIndex + 1) {
      if (this.isStepValid(this.currentStepIndex)) {
        this.currentStepIndex = targetIndex;
        event.selectedIndex = targetIndex;
      } else {
        alert("Please fill required fields.");
      }
    }
  }

  onItemSelect(item: any) {
    void 0;
    void 0;
    const selected = this.addGrsForm.value.locationTypeId;
    void 0;
    // void 0;
    const Selectedids = this.selectedLocations.map((x) => {
      return x.id;
    });
    void 0;
    this.setLocationCategoryMapping(Selectedids);
    // this.setSublocationsAndSublocationsvalidations(Selectedids);
    this.addGrsForm.controls.locationTypeId.setValue(Selectedids);

    const selected2 = this.addGrsForm.value.locationTypeId;
    void 0;
  }

  onCategorySelect(item: any) {
    if (item && item.id) {
      this.selectedCategory = [item];
      this.setCategory(item.id);
      this.categoryForLastPage = item.name;
    }
  }

  onCategoryDeSelect(item: any) {
    if (item && item.id) {
      this.selectedCategory = [item];
      this.categoryForLastPage = item.name;
      this.setCategory(item.id);
      return;
    }
  }

  onSelectAll(items: any) {
    void 0;
    // void 0;
    const AllSelectedids = items.map((x) => {
      return x.id;
    });
    this.setSublocationsAndSublocationsvalidations(AllSelectedids);
    this.addGrsForm.controls.locationTypeId.setValue(AllSelectedids);
  }

  onDropdownOpen() {
    // alert("open");
  }

  onSubLocationSelect(item: any) {
    if (item && item.id) {
      this.subLocationselected = [item];
      this.lastPageSublocation = item.name;
      this.setSubLocation(item.id);
    }
  }

  onSubLocationDeSelect(item: any) {
    if (item && item.id) {
      this.subLocationselected = [item];
      this.lastPageSublocation = item.name;
      this.setSubLocation(item.id);
      return;
    }
  }

  onMinimumStandardSelect(item: any) {
    const selected = this.addGrsForm.value.minimumStandadId;
    void 0;

    const Selectedids = this.minimumStandardSelected.map((x) => {
      return x.id;
    });

    this.dependentStandardsItems = this.minimumStandads.filter((std) =>
      Selectedids.includes(std.id),
    );
    void 0;

    this.dependentcategories = [
      ...new Set(this.dependentStandardsItems.map((ds) => ds.category.name)),
    ].join(", ");
    void 0;
    this.dependentLocations = [
      ...new Set(
        this.dependentStandardsItems.map((ds) => ds.locationType.name),
      ),
    ].join(", ");

    this.addGrsForm.controls.minimumStandadId.setValue(Selectedids);
    console.log(
      "minimumstandad",
      this.addGrsForm.controls.minimumStandadId.value,
    );
  }

  isStepValid(stepIndex: number): boolean {
    if (stepIndex === 0) {
      return this.addGrsForm.get("standardTypeId")?.valid;
    }
    // if (stepIndex === 1) {
    //   return this.sharedForm.get('field2')?.valid;
    // }
    // return true;
  }
  clearAllSelected() {
    this.selectedLocations = [];
    this.addGrsForm.controls.locationTypeId.setValue([]);
    // this.locationDropdown.clearAll();
  }

  checkFormFieldValidations(group: FormGroup) {
    // alert(this.currentStepIndex);
    void 0;
    if (this.currentStepIndex == 0) {
      const { standardTypeId } = group.controls;
      return standardTypeId.valid ? null : { stepInvalid: true };
    }
    if (this.currentStepIndex == 1) {
      // alert("step 1 validation");
      const { title, categoryId, locationTypeId, subLocationTypeId } =
        group.controls;
      return title.valid &&
        categoryId.valid &&
        locationTypeId.valid &&
        subLocationTypeId.valid
        ? null
        : { stepInvalid: true };
    }
    if (this.currentStepIndex == 2) {
      const controls = group.controls;
      const minStdValid = controls.minimumStandadId ? controls.minimumStandadId.valid : true;
      const descValid = controls.description ? controls.description.valid : true;
      const newDescValid = controls.newrestaurantdescription ? controls.newrestaurantdescription.valid : true;
      return minStdValid && descValid && newDescValid
        ? null
        : { stepInvalid: true };
    }
    if (this.currentStepIndex == 3) {
      const { note, linksFieldValid } = group.controls;

      return (note ? note.valid : true) && (linksFieldValid ? linksFieldValid.valid : true)
        ? null
        : { stepInvalid: true };
    }
    if (this.currentStepIndex == 4) {
      const { keyContact } = group.controls;

      return keyContact ? (keyContact.valid ? null : { stepInvalid: true }) : null;
    }
  }

  checkFormValidity() {
    if (!this.addGrsForm) return false;
    const stdTypeId = Number(this.addGrsForm.get("standardTypeId")?.value || this.grs?.standard?.standardTypeId);
    const isGlobal = this.globalstandards ?? (
      stdTypeId == 4 || stdTypeId == 1 || stdTypeId == 7 || stdTypeId == 8 || stdTypeId == 11
    );

    const titleCtrl = this.addGrsForm.get("title");
    const titleValid = titleCtrl ? (titleCtrl.valid || titleCtrl.disabled) : true;

    const descCtrl = this.addGrsForm.get("description");
    const descValid = descCtrl ? (descCtrl.valid || descCtrl.disabled) : true;

    const newDescCtrl = this.addGrsForm.get("newrestaurantdescription");
    const newDescValid = newDescCtrl ? (newDescCtrl.valid || newDescCtrl.disabled) : true;

    const noteCtrl = this.addGrsForm.get("note");
    const noteValid = noteCtrl ? (noteCtrl.valid || noteCtrl.disabled) : true;

    const locCtrl = this.addGrsForm.get("locationTypeId");
    const locValid = isGlobal ? (locCtrl ? (locCtrl.valid || locCtrl.disabled) : true) : true;

    const catCtrl = this.addGrsForm.get("categoryId");
    const catValid =
      isGlobal && (stdTypeId === 4 || stdTypeId === this.standardTypeEnum.GlobalMinimumRestaurantStandard)
        ? (catCtrl ? (catCtrl.valid || catCtrl.disabled) : true)
        : true;

    const minStdCtrl = this.addGrsForm.get("minimumStandadId");
    const minStdValid = !isGlobal
      ? (minStdCtrl ? (minStdCtrl.valid || minStdCtrl.disabled) : true)
      : true;

    return !(
      titleValid &&
      descValid &&
      newDescValid &&
      noteValid &&
      locValid &&
      catValid &&
      minStdValid
    );
  }
  onPasteLink(event: ClipboardEvent, link) {
    event.preventDefault();
    const pastedText = event.clipboardData?.getData("text") || "";

    if (!pastedText.includes("mcd.com")) {
      alert("Not a valid URL");
    } else {
      link.get("url")?.setValue(pastedText);
      const url = link.get("url")?.value;
      const title = link.get("title")?.value;
      if (title && url) {
        this.addGrsForm.get("linksFieldValid")?.clearValidators();
        this.addGrsForm.get("linksFieldValid")?.updateValueAndValidity();
      } else {
        this.addGrsForm
          .get("linksFieldValid")
          ?.setValidators(Validators.required);
        this.addGrsForm.get("linksFieldValid")?.updateValueAndValidity();
      }
    }
  }
  toggleDetails() {
    this.detailsExpanded = !this.detailsExpanded;
  }
  toggleDetails2() {
    this.additionalInfoExpanded = !this.additionalInfoExpanded;
  }

  copyText(content: any) {
    void 0;
    navigator.clipboard.writeText(content);
    this.openSnackBar();
  }

  getDetails() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.addGrsForm.get("note")?.value,
    );
  }
  getAdditionalInfo() {
    return this.sanitizer.bypassSecurityTrustHtml(
      this.addGrsForm.get("additionalInformation")?.value,
    );
  }
  onChildSelection(selected: any[]) {
    void 0;

    const Selectedids = selected.map((x) => {
      return x.id;
    });
    this.addGrsForm.controls.minimumStandadId.setValue(Selectedids);
    this.selectedFromChild = selected.map((x) => x.title).join(", ");
    void 0;
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: Event) {
    const clickedInsideInput = this.dropdownContainer?.nativeElement.contains(
      event.target,
    );
    if (!clickedInsideInput) {
      this.minimumStandads = [];
      this.minimumStandadControl.setValue("", { emitEvent: false });
      this.showDependentDropdown = false;
      this.searched = false;
    }
  }
  openDropdown() {
    this.showDependentStandardsItems = true;
  }

  // onChildQuery(query:string){

  //   if(query.length> 4){
  //     void 0;
  //     // this.showDependentStandardsItems = false;
  //     this.onSearchInputChange(query)
  //   }
  // }
  onSearchInputChange(searchTerm: string) {
    this.searchDependentStandardsTerm = searchTerm;
    if (this.selectFromDepenedentStandard.length > 0 && searchTerm == "") {
      this.minimumStandads = [];
    }
    if (searchTerm.length == 0) {
      this.searched = false;
      this.minimumStandads = [];
    }
    // void 0;
    // this.searchDependentStandardsTerm = searchTerm;

    // this.showDependentStandardsItems = true;
    this.searchSubject.next(searchTerm);
  }
  isSelected(item: any): boolean {
    return this.selectedDependentStandardsMap.has(item.id);
  }

  selectDependentrow(item: any) {
    const checked = !this.selectedDependentStandardsMap.has(item.id);
    this.selectItem(checked, item);
  }

  selectItem(checked: boolean, item: any) {
    if (checked) {
      this.selectedDependentStandardsMap.set(item.id, item);
    } else {
      this.selectedDependentStandardsMap.delete(item.id);
    }

    this.selectFromDepenedentStandard = [
      ...this.selectedDependentStandardsMap.values(),
    ];

    const Selectedids = [...this.selectedDependentStandardsMap.keys()];

    this.dependentcategories = [
      ...new Set(
        this.selectFromDepenedentStandard.map((ds) => ds.category.name),
      ),
    ].join(", ");
    void 0;
    this.dependentLocations = [
      ...new Set(
        this.selectFromDepenedentStandard.map((ds) => ds.locationType.name),
      ),
    ].join(", ");
    this.addGrsForm.controls.minimumStandadId.setValue(Selectedids);
    // console.log(
    //   "addGrs form depenedent",
    //   this.addGrsForm.controls.minimumStandadId.value,
    // );
  }

  removeItem(item: any) {
    this.selectItem(false, item);
  }
  toggleDropdown() {
    this.showDependentDropdown = !this.showDependentDropdown;
    setTimeout(() => {
      this.searchInput?.nativeElement.focus();
    }, 0);
  }
  clearSearch() {
    this.minimumStandadControl.setValue("");
    this.searched = false;
    this.minimumStandads = [];
    this.minimumStandardsLoading = false;
    setTimeout(() => {
      this.searchInput?.nativeElement.focus();
    }, 0);
  }

  openSnackBar() {
    this._snackBar.openFromComponent(SnackbarComponent, {
      duration: 2 * 1000,
      data: {
        message: "Object Copied to clipboard!",
      },
    });
  }

  disableTyping(event: KeyboardEvent) {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === "v") {
      return;
    }

    const allowedKeys = [
      "Tab",
      "ArrowLeft",
      "ArrowRight",
      "ArrowUp",
      "ArrowDown",
    ];

    if (!allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }
}
